/* PR5 – linija pomeranja ispod reda "Upotpuni komplet" (samo kad red ne staje) */
(function(){
  function init(row){
    if(row.dataset.prMatch) return; row.dataset.prMatch='1';
    var bar=row.parentElement.querySelector('.elia-pr-match-progress'); if(!bar) return;
    var fill=bar.querySelector('span');
    function update(){
      var over=row.scrollWidth>row.clientWidth+2; bar.hidden=!over; if(!over) return;
      var ratio=row.clientWidth/row.scrollWidth; fill.style.width=(ratio*100)+'%';
      var max=row.scrollWidth-row.clientWidth; fill.style.transform='translateX('+((max?row.scrollLeft/max:0)*(1/ratio-1)*100)+'%)';
    }
    row.addEventListener('scroll',function(){requestAnimationFrame(update)},{passive:true});
    window.addEventListener('resize',update); update(); setTimeout(update,800);
  }
  function run(){document.querySelectorAll('.elia-pr-match-row').forEach(init)}
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',run); else run();
  document.addEventListener('shopify:section:load',run);
  new MutationObserver(run).observe(document.documentElement,{childList:true,subtree:true});
})();
